<template>
  <div class="c-app app header-fixed sidebar-fixed sidebar-lg-show">
    <ThePageHeader v-if="IS_MZ_BRANDING"/>
    <TheHeader v-else/>
    <TheSidebar/>
    <CWrapper>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <MzBreadcrumbRouter class="unset-text-transform"/>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheFooter from './TheFooter'
import ThePageHeader from './ThePageHeader'
import TheHeader from './TheHeader'
import { IS_MZ_BRANDING } from '@/constants/config';
import {ActiveUser} from "@/services/user";

export default {
  name: 'TheContainer',
  data() {
    return {
      IS_MZ_BRANDING,
    };
  },
  components: {
    TheSidebar,
    TheFooter,
    ThePageHeader,
    TheHeader,
  },
  beforeCreate() {
    // if user is not authenticated it will redirect to login
    if (ActiveUser.getToken()) {
      ActiveUser.getMeta();
      if (this.$route?.query?.lang) ActiveUser.setLanguage(to.query.lang);
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<style>
.unset-text-transform .breadcrumb-item > a.text-capitalize {
  text-transform: none !important;
}

.c-sidebar .c-sidebar-nav-link.c-active, .c-sidebar .c-active.c-sidebar-nav-dropdown-toggle {
  font-weight: 900 !important;
}
</style>
